<div class="auth-nav">
    <div class="auth-nav-link" [class.active]="!emailSubmitted()"></div>
    <div class="auth-nav-link" [class.active]="emailSubmitted()"></div>
</div>
@if (showHeader) {
    <div class="auth-header">
        <div class="auth-title">{{ formHeader() }}</div>
        <p class="auth-subtitle">{{ formSubtitle() }}</p>
    </div>
}

@if (showSocialLogin()) {
    <div class="form-row row">
        <div class="col-6">
            <form method="post" [action]="googleLoginUrl" ngNoForm>
                <input type="hidden" name="csrfmiddlewaretoken" [value]="csrfToken">
                <input type="hidden" name="process" value="login">
                @if (next) {
                    <input type="hidden" name="next" [value]="next">
                }
                <button type="submit" class="btn btn-secondary width-full height-40">
                    <svg ycnIcon name="icon-google-color" class="width-20 height-20"></svg>
                    <span class="text-normal text-normal-case tracking-normal">Continue with Google</span>
                </button>
            </form>
        </div>
        <div class="col-6">
            <form method="post" [action]="linkedinLoginUrl" ngNoForm>
                <input type="hidden" name="csrfmiddlewaretoken" [value]="csrfToken">
                <input type="hidden" name="process" value="login">
                @if (next) {
                    <input type="hidden" name="next" [value]="next">
                }
                <button type="submit" class="btn btn-secondary width-full height-40">
                    <svg ycnIcon name="icon-linkedin-color" class="width-20 height-20"></svg>
                    <span class="text-normal text-normal-case tracking-normal">Continue with LinkedIn</span>
                </button>
            </form>
        </div>
    </div>
    <div class="form-row row align-items-center pt-1 pb-1">
        <div class="col">
            <div class="border-b border-color-gray-80"></div>
        </div>
        <div class="col-auto pl-4 pr-4"><span class="text-uppercase text-gray-50">Or continue with</span></div>
        <div class="col">
            <div class="border-b border-color-gray-80"></div>
        </div>
    </div>
}
<form action="{{ actionUrl }}" method="post" (ngSubmit)="onSubmit($event)" ngNativeValidate>
    <input type="hidden" name="csrfmiddlewaretoken" value="{{ csrfToken }}"
           autocomplete="off">
    <div class="auth-form">
        @if (!emailSubmitted()) {
            @if (!loggedIn) {
                <div class="form-row">
                    <label class="form-label form-label-thin">E-mail Address</label>
                    <input class="form-control" type="email" placeholder="name@company.com"
                           [(ngModel)]="form.email" name="email"
                           [ngModelOptions]="{updateOn: 'blur'}"
                           ycnNgModelChangeDebounced (debouncedChangeHandler)="validateEmail()"
                           [ngClass]="{'is-invalid': errors.email, 'disabled': fieldDisabled('email') || socialSignup}"
                           maxlength="75" required
                           [readonly]="fieldDisabled('email') || socialSignup">
                    @if (linkAccountUrl && errors.email === DUPLICATE_EMAIL_ERROR) {
                        <div [ngClass]="{'feedback feedback-invalid': errors.email}">
                            A user with this email already exists. <a [href]="linkAccountUrl">Please link your account.</a>
                        </div>
                    } @else {
                        <div [ngClass]="{'feedback feedback-invalid': errors.email}">
                            {{ errors.email }}
                        </div>
                    }
                </div>
            }
            @if (!loggedIn && !socialSignup) {
                <div class="form-row">
                    <label class="form-label form-label-thin">Create Password</label>
                    <div class="field-input-group input-group field-input-group-password">
                        <input class="form-control field-input" type="password" placeholder="Password"
                               [(ngModel)]="form.password" name="password" id="id_password"
                               [ngModelOptions]="{updateOn: 'blur'}"
                               ycnNgModelChangeDebounced (debouncedChangeHandler)="validatePassword()"
                               [ngClass]="{'is-invalid': errors.password, 'disabled': fieldDisabled('password')}"
                               maxlength="50" minlength="8" required
                               [readonly]="fieldDisabled('password')">
                        <ycn-password-reveal
                            passwordElementId="id_password">  <!-- pragma: allowlist-secret -->
                        </ycn-password-reveal>
                    </div>
                    <div [ngClass]="{'feedback feedback-invalid': errors.password}">{{errors.password}}</div>
                </div>
            }
            <div class="form-row">
                <button type="button" class="btn btn-block btn-xxl btn-blue-ada"
                        [disabled]="emailValidationPending()" (click)="submitEmail()">Get Started</button>
            </div>
        }
        <!-- Hidden rather than removed so the explicitly-rendered captcha survives Back -->
        <div [style.display]="emailSubmitted() ? null : 'none'">
            @if (!loggedIn) {
                <input type="hidden" name="email" [value]="form.email">
            }
            @if (!loggedIn && !socialSignup) {
                <input type="hidden" name="password" [value]="form.password">
            }
            <div class="row">
                <div class="col-6 form-row">
                    <label class="form-label form-label-thin">First Name</label>
                    <input class="form-control" type="text" placeholder="First Name"
                           [(ngModel)]="form.firstName" name="first_name" maxlength="30" required
                           [ngClass]="{'disabled': fieldDisabled('first-name')}"
                           [readonly]="fieldDisabled('first-name')">
                </div>
                <div class="col-6 form-row">
                    <label class="form-label form-label-thin">Last Name</label>
                    <input class="form-control" type="text" placeholder="Last Name"
                           [(ngModel)]="form.lastName" name="last_name" maxlength="30" required
                           [ngClass]="{'disabled': fieldDisabled('last-name')}"
                           [readonly]="fieldDisabled('last-name')">
                </div>
            </div>
            <div class="form-row">
                <label class="form-label form-label-thin">Job Function</label>
                <div class="select">
                    <select class="form-control" [(ngModel)]="form.jobFunction" name="job_function" required>
                        <option value="" selected="">-------</option>
                        <option value="registered_investment_advisor">Registered Investment Advisor</option>
                        <option value="investment_professional">Investment Professional</option>
                        <option value="finance_professional">Finance Professional</option>
                        <option value="consultant_or_banker">Consultant / Banker</option>
                        <option value="personal_investor">Personal Investor</option>
                        <option value="student_or_educator">Student / Educator</option>
                        <option value="wholesaler">Investment Wholesaler</option>
                    </select>
                </div>
            </div>
            @if (!ssoSignup) {
                <div class="form-row">
                    <label class="form-label form-label-thin">Company Name</label>
                    <input class="form-control" type="text" placeholder="Company Name"
                           [(ngModel)]="form.organization" name="organization" maxlength="100">
                </div>
                <div class="form-row">
                    <label class="form-label form-label-thin">Phone Number</label>
                    <input class="form-control" type="text" placeholder="Phone Number"
                           [(ngModel)]="form.phone" name="phone_number"
                           [ngModelOptions]="{updateOn: 'blur'}"
                           ycnNgModelChangeDebounced (debouncedChangeHandler)="validatePhone()"
                           [ngClass]="{'is-invalid': errors.phone}"
                           maxlength="30" required>
                    <div [ngClass]="{'feedback feedback-invalid': errors.phone}">{{errors.phone}}</div>
                </div>
            } @else {
                <div class="row">
                    <div class="form-row col-6">
                        <label class="form-label form-label-thin">Phone Number</label>
                        <input class="form-control" type="text" placeholder="Phone Number"
                               [(ngModel)]="form.phone" name="phone_number"
                               [ngModelOptions]="{updateOn: 'blur'}"
                               ycnNgModelChangeDebounced (debouncedChangeHandler)="validatePhone()"
                               [ngClass]="{'is-invalid': errors.phone, 'disabled': fieldDisabled('phone-number')}"
                               maxlength="30" required
                               [readonly]="fieldDisabled('phone-number')">
                        <div [ngClass]="{'feedback feedback-invalid': errors.phone}">{{errors.phone}}</div>
                    </div>
                    <div class="form-row col-6">
                        <label class="form-label form-label-thin">Company Name</label>
                        <input class="form-control" type="text" placeholder="Company Name"
                               [(ngModel)]="form.organization" name="organization" maxlength="100"
                               [ngClass]="{'disabled': fieldDisabled('organization')}"
                               [readonly]="fieldDisabled('organization')">
                    </div>
                </div>
            }
            <div class="form-row">
                <div id="captcha-element"></div>
            </div>
            <div class="form-row form-row-accept user-select-none">
                <label class="custom-control custom-checkbox custom-checkbox-large">
                    <input class="custom-control-input custom-control-indicator"
                           [(ngModel)]="form.terms" type="checkbox" name="terms" required>
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description">
                        By checking this box you are indicating that you have read and accepted the
                        <a href="{{ termsUrl }}">Terms of Use</a>
                    </span>
                </label>
            </div>
            <div class="form-row">
                @if (!isSaving) {
                    <input type="submit" class="btn btn-block btn-xxl btn-blue-ada"
                           [disabled]="!emailSubmitted() || !isValidForm()"
                           value="Get Started">
                }
            </div>
            @if (!loggedIn) {
                <div class="form-row text-center">
                    <button type="button" class="btn btn-link" (click)="editEmail()">Back</button>
                </div>
            }
        </div>
        @if (isSaving) {
            <ycn-loading-symbol></ycn-loading-symbol>
        }
    </div>
</form>
